import { SVGProps } from 'react'

const ArrowUpDownIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M2.66943 11.9248L5.59416 14.8495L8.5189 11.9248'
                stroke='#959699'
                strokeWidth='1.46237'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.59424 14.8498V3.15088'
                stroke='#959699'
                strokeWidth='1.46237'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.8309 6.07561L12.9062 3.15088L9.98145 6.07561'
                stroke='#959699'
                strokeWidth='1.46237'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9053 3.15088V14.8498'
                stroke='#959699'
                strokeWidth='1.46237'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ArrowUpDownIcon
